import styled from 'styled-components/macro';
import Helmet from 'react-helmet';
import Buscador from '../components/Buscador';
import React, { useEffect, useMemo, useState } from 'react';

import { useTranslate } from '../contexts/languageContext';
import { useIsDesktop, useIsDesktopReal } from '../hooks/useMediaQuery';
import useIni from '../hooks/useIni';
import { responsive, eleccion as _elec } from '../resources/constantes.json';
import { withRouter } from 'react-router-dom';

import qrAndroid from '../assets/img/qr-android.png';
import qriOS from '../assets/img/qr-apple.png';
import logoAndroid from '../assets/img/google-play-badge.png';
import logoIOS from '../assets/img/iOS.svg';
import bgInicio from '../assets/img/bg-inicio.svg';
import LogoRegistraduria from '../assets/img/logosIni.svg';
import LogoEleccion from '../assets/img/logoCol.svg';
import { motion } from 'framer-motion';
import TarjetasInicio from '../containers/TarjetasInicio';
import DropdownMapa from '../containers/DropdownMapa';
import Mapa from '../containers/Mapa';
import Header from '../containers/Header';
import { usePage, useSetPage } from '../contexts/pageContext';
import { useSetEleccion } from '../contexts/eleccionContext';
import LowerBanner from '../containers/LowerBanner';
import constantes from 'constantes';
import FooterLayout from '../components/Footer/Footer';
import { useMap } from '../contexts/mapContext';
import SelectMapa from '../containers/SelectMapa';
import { themes } from '../styles/themes';
import Logo from '../assets/img/COBRANDING_ELECCIONES_2023-08.png';
import { useMesa } from '../contexts/viewContext';

const eleccion = Number(_elec.inicio); // Esta variable se usar para buscar un id en el nomenclator, debo ser 10 para este caso

/**
 * Página que sirve de inicio y que muestra un resumen de resultados para todas las elecciones
 */

const Inicio = ({ nomenclator, location }) => {
  const t = useTranslate();
  const isDesktop = useIsDesktopReal();
  const ini = useIni();
  // const items = ini?.botones;
  const isClosed = ini?.isClosed;
  const pageState = usePage();
  const setPage = useSetPage();
  const setElecOptions = useSetEleccion();
  const { data, urlInfo } = pageState;
  const [arrayPairElectionAmbito, setArrayPairElectionAmbito] = useState([]);
  const [ambito, setAmbito] = useState();
  const [ambitoIState, setAmbitoIState] = useState();
  const [elecMapa, setElecMapa] = useState(data?.[0]?.elec ?? '3');
  const { setMesa } = useMesa();

  useEffect(() => {
    const regex = /\/(\d+)\//;
    const match = location.pathname.match(regex);
    const ambitoI = match && match[1] ? match[1] : '0';

    setAmbitoIState(ambitoI);
    const nuevoAmbito =
      nomenclator.ambitos[constantes.eleccion.inicio][ambitoI];

    setAmbito(nuevoAmbito);
  }, [location.pathname, nomenclator.ambitos]);

  useEffect(() => {
    if (data && !data.find(({ elec }) => elec === String(elecMapa))) {
      if (data?.[0]?.elec !== elecMapa) {
        setElecMapa(data?.[0]?.elec);
      }
    }
  }, [data, elecMapa]);

  useEffect(() => {
    const getPairElectionAmbito = () => {
      const { ordAmbitos, ambitos } = nomenclator;

      const pairElectionAmbito = ambito?.r
        .slice(0, 5)
        .reduce((electionAmbito, nomenclatorAmbitoPosition, index) => {
          if (nomenclatorAmbitoPosition === -1) {
            return electionAmbito;
          } else {
            const eleccion = ordAmbitos[index];
            const ambitoActual = ambitos[eleccion];
            return [
              ...electionAmbito,
              {
                eleccion: constantes.abbrCodigoEleccionAEleccion[eleccion],
                ambito: ambitoActual[nomenclatorAmbitoPosition],
              },
            ];
          }
        }, []);
      return pairElectionAmbito;
    };

    const pairElectionAmbito = getPairElectionAmbito();

    const regex = /\/(\d+)\//;
    const match = location.pathname.match(regex);
    const ambitoI = match && match[1] ? match[1] : '0';
    if (pairElectionAmbito && ambitoI === ambitoIState) {
      setArrayPairElectionAmbito(pairElectionAmbito);
      if (pairElectionAmbito && pairElectionAmbito.length > 0) {
        setPage(
          pairElectionAmbito.map(
            ({ eleccion, ambito }) =>
              `/json/INI/${eleccion}/IN_${ambito.c ?? '00'}.json`
          ),
          {
            eleccion: 10,
            id: ambitoI,
            page: 'inicio',
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ambitoIState, setPage, location]);
  //   }, [ambitoIState, setPage, location]);

  useMemo(() => {
    if (data) {
      setElecOptions();
      setMesa(null);
    }
  }, [data, setElecOptions, setMesa]);

  useEffect(() => {
    if (data) {
      setElecOptions();
    }
  }, [data, setElecOptions]);
  useEffect(() => {
    document.title = 'Elecciones Territoriales 2023';
  }, []);

  const { selectedMap, setSelectedMap, maps } = useMap();
  const mapData = useMemo(
    () => data?.find?.(d => d.elec === String(elecMapa))?.mapapar ?? [],
    [data, elecMapa]
  );
  if (!urlInfo || !ambito || !data?.length) return null;
  return (
    <Main>
      {isClosed ? (
        <LayoutInicio ini={ini}>
          <Content>
            <TextContainer>
              <TextClosed>{t('inicioClose')}</TextClosed>
            </TextContainer>
          </Content>
        </LayoutInicio>
      ) : (
        <>
          {isDesktop ? (
            <HeaderDesktop>
              <LogoContainer>
                <img
                  src={Logo}
                  alt={'Logos'}
                  style={{ padding: '0px', height: '100%' }}
                />
              </LogoContainer>
              <LowerBanner
                nomenclator={nomenclator}
                ambito={ambito}
                eleccion={eleccion}
                page={'inicio'}
                variant={'inicio'}
                esHistorico={false}
                data={data}
              />
            </HeaderDesktop>
          ) : (
            <Header
              page={'inicio'}
              variant={'home'}
              nomenclator={nomenclator}
              eleccion={eleccion}
              ambito={ambito}
            />
          )}
          <ContentInit>
            <Column shouldSetMinWidth={true}>
              <TarjetasInicio
                data={data}
                nomenclator={nomenclator}
                arrayPairElectionAmbito={arrayPairElectionAmbito}
                location={location}
              />
            </Column>
            <Column>
              <Mapa
                {...urlInfo}
                variant="inicio"
                amb={ambito?.c}
                data={data}
                nomenclator={nomenclator}
                mapData={mapData}
                ambito={ambito}
                esHistorico={false}
                eleccion={String(elecMapa)}
                citrep={false}
              >
                <FilDiv>
                  <ColDiv style={{ alignItems: 'center' }}>
                    <DropdownMapa
                      elec={elecMapa}
                      setElec={setElecMapa}
                      ordEleccion={
                        data?.map?.(({ elec }) => elec) ??
                        nomenclator.ordAmbitos
                      }
                    />
                  </ColDiv>
                  {maps.length >= 2 && (
                    <ColDiv>
                      <SelectMapa elec={selectedMap} setElec={setSelectedMap} />
                    </ColDiv>
                  )}
                </FilDiv>
              </Mapa>
            </Column>
          </ContentInit>
          <ContentFooter>
            <FooterLayout />
          </ContentFooter>
        </>
      )}
    </Main>
  );
};

export function LayoutInicio({ children, ini }) {
  const t = useTranslate();
  const isDesktop = useIsDesktop();
  const appsVisibles = ini?.appsVisibles;
  return (
    <div>
      <Helmet>
        <title itemProp="name" lang="es">
          Elecciones territoriales 2023
        </title>
      </Helmet>
      <MainLayout>
        <SLogoRegistraduria>
          <img src={LogoRegistraduria} alt={'Logo Registraduria'} />
        </SLogoRegistraduria>
        <ContainerInicio>
          <LeftSide>
            <MainContainer>
              <motion.div
                initial={{ opacity: 0, x: -500 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <MainTitle>
                  <span>{t('tituloMainInicio1')}</span>
                  <span>{t('tituloMainInicio2')}</span>
                </MainTitle>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: -500 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4rem',
                }}
              >
                <Notes>
                  <TextoLegal>{t('footer2')}</TextoLegal>
                </Notes>
                {children}
                <AppsContainer isDesktop={isDesktop}>
                  <QrText>{t('qrText')}</QrText>
                  <QrBlock isDesktop={isDesktop} visible={appsVisibles} />
                </AppsContainer>
              </motion.div>
            </MainContainer>
          </LeftSide>
          <RightSide>
            <motion.div
              initial={{ opacity: 0, x: 500 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <SLogoEleccion>
                <LogoEleccion alt={'Logo elección'} />
              </SLogoEleccion>
            </motion.div>
          </RightSide>
        </ContainerInicio>
      </MainLayout>
    </div>
  );
}

export function QrBlock({ isDesktop, visible = true }) {
  const t = useTranslate();
  return (
    <>
      {visible && (
        <QrContainer>
          <AppBlock isDesktop={isDesktop}>
            {isDesktop && (
              <QRImage src={qriOS} alt={t('qriOS')} element="right" />
            )}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={
                'https://apps.apple.com/us/app/territoriales-colombia-2023/id6467455253'
              }
            >
              <ShopLogo src={logoIOS} alt="App Store" element="right" />
            </a>
          </AppBlock>
          <AppBlock isDesktop={isDesktop}>
            {isDesktop && (
              <QRImage src={qrAndroid} alt={t('qrAndroid')} element="left" />
            )}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={
                'https://play.google.com/store/apps/details?id=co.registraduria.gov.elecciones.territorialescolombia2023'
              }
            >
              <ShopLogoAndroid
                src={logoAndroid}
                alt="Google Play"
                element="left"
              />
            </a>
          </AppBlock>
        </QrContainer>
      )}
    </>
  );
}

const ContentFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  background-color: ${themes.inicio.backgroundColor};
  color: black;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    padding: 20px;
  }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: ${({ shouldSetMinWidth }) => (shouldSetMinWidth ? '575px' : '')};
  @media (max-width: ${responsive.mobile}px) {
    min-width: unset;
  }
`;

const MainLayout = styled.main`
  background-image: url(${bgInicio});
  background-size: cover;
  height: 100%;
  min-height: 100vh;
  display: block;
`;

const SLogoRegistraduria = styled.div`
  position: absolute;
  display: block;
  left: 50%;
  transform: translateX(-50%);
  height: 10vh;
  img {
    height: 115px;
    @media screen and (max-width: ${responsive.tablet}px) {
      margin: auto;
      display: block;
      height: 100px;
    }
    @media (max-width: ${responsive.maxWidth.mobile}px) {
      width: 95%;
    }
  }
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    left: 0;
    transform: initial;
    width: 100%;
  }
`;

const TextContainer = styled.div`
  text-align: left;
  font-size: 2rem;
  margin-bottom: 14px;
  color: #2f435f;
  font-weight: 400;
`;
const Notes = styled.div`
  box-sizing: border-box;
  padding: 0 0 0.5rem 0;
  font-size: 1.3rem;
  color: #fff;
  width: 60%;
  text-align: center;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 90%;
  }
`;

/*
 *  Main layout
 */

const MainContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: 4rem;
`;

const SLogoEleccion = styled.div`
  display: flex;
  justify-content: center;
  svg {
    width: 70%;
    max-height: 70vh;
    @media (max-width: 1200px) {
      width: 30%;
    }
    @media screen and (max-height: 400px) {
      height: 80%;
      margin-top: 20px;
    }
  }
  @media (max-width: 1200px) {
    width: 100%;
    height: 75%;
  }
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    height: 100%;
  }
`;

const MainTitle = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Lato;
  text-align: center;
  line-height: initial;
  color: #ffffff;
  width: 65%;
  span:first-child {
    font-weight: 100;
    font-size: 28px;
    @media screen and (max-width: ${responsive.tablet}px) {
      font-size: 18px;
      width: 90%;
      margin: 0 auto;
    }
  }
  span:nth-child(2) {
    font-weight: 400;
    font-size: 32px;
    @media screen and (max-width: ${responsive.tablet}px) {
      font-size: 24px;
      width: 90%;
      margin: 0 auto;
    }
  }
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 80%;
  }
`;

const TextClosed = styled.p`
  font-family: Lato;
  font-weight: 400;
  font-size: 3rem;
  color: #ffca1c;
  width: 60%;
  text-align: center;
  margin: auto;
  line-height: 4rem;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 90%;
    font-size: 2rem;
    line-height: 3rem;
  }
`;

const LeftSide = styled.div`
  width: 50%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media screen and (max-height: 1000px) {
    margin-top: 10%;
    height: 90%;
  }
  @media (max-width: 1200px) {
    width: 90%;
    margin: auto;
    height: auto;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-height: 1000px) {
    margin-top: 10%;
    height: 90%;
  }
  @media (max-width: 1200px) {
    width: 90%;
    margin: auto;
    height: 20vh;
    margin-bottom: 2rem;
  }
  @media screen and (max-height: 375px) {
    height: 5%;
  }
`;

const ContainerInicio = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  @media (max-width: 1200px) {
    padding-top: 20%;
    flex-direction: column-reverse;
  }
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    padding-top: 25%;
  }
`;

const Content = styled.div``;
const ContentInit = styled.div`
  display: flex;
  column-gap: 40px;
  padding: 40px;
  @media (max-width: ${responsive.mobile}px) {
    padding: 40px 10px;
  }
  @media (max-width: 1200px) {
    flex-direction: column-reverse;
  }
  background-color: #fff;
`;

const AppsContainer = styled.div`
  width: 50%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 15px;
  padding: 1rem 0;
  @media (max-width: ${responsive.tablet}px) {
    width: 70%;
    margin-bottom: 5vh;
  }
`;

const QrContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0.5rem 3rem;
  @media (max-width: ${responsive.tablet}px) {
    justify-content: space-between;
  }
`;

const AppBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 105px;
  @media (max-width: ${responsive.tablet}px) {
    margin-right: 0px;
  }
`;

const QRImage = styled.img`
  height: 150px;
  width: 150px;
`;

const ShopLogo = styled.img`
  height: 30px;
  margin-top: 4px;
  @media (max-width: ${responsive.mobile}px) {
    margin-right: 5px;
  }
`;

const ShopLogoAndroid = styled.img`
  height: 38px;
  margin-top: 0px;
`;

const QrText = styled.span`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #172946;
`;

const TextoLegal = styled.p`
  text-align: left;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    text-align: justify;
  }
`;

const SBuscador = styled(Buscador)`
  margin-left: auto;
  align-self: flex-end;
  height: 34px;
  flex: 0 2 250px;
  color: white;
  //background-color: #fff;
  //border-radius: 30px;
  @media print {
    display: none;
  }
  @media (max-width: ${responsive.tablet}px) {
    width: '50%';
  }
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: '50%';
  }
`;

const Main = styled(({ ...rest }) => <div {...rest} />)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  width: auto;
  height: 100%;
  margin: auto;
  margin-top: 0;
  margin-bottom: 0;
  @media (max-width: ${responsive.tablet}px) {
    margin-top: '0px';
  }
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    margin-top: 0px;
  }
`;

const FilDiv = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  z-index: 1;
  top: 12px;
  width: 100%;
  justify-content: center;

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    margin: 0 10px;
    justify-content: center;
  }
`;

const ColDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 90%;
  }
`;
const HeaderDesktop = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding-left: 50px;
`;

const LogoContainer = styled.span`
  height: 100px;
  @media (max-width: 1400px) {
    height: 70px;
  }
`;

/**************************************************/
export default withRouter(Inicio);
